import React from 'react';
import {Banner} from '@albert-io/atomic';

interface WarningHeaderProps {
  text?: string;
}
const NoTranslationWarningHeader = ({text = 'No translations available'}: WarningHeaderProps) => {
  return (
    <Banner type='warning'>
      <Banner.Icon icon='info-circle' />
      {text}
    </Banner>
  );
};

export const answerInEnglishText = 'Escribe tu respuesta en inglés.';
export const btnDisabledWarning =
  'Las traducciones deben estar “desfasadas” para poder responder a esta pregunta.';

export default NoTranslationWarningHeader;
